import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';
import API from 'api';
import moment from 'moment';

const fields = (
	ROLE: 'STUDENT' | 'CANDIDATE',
	props: {admissionFacultyIDs: any[]}
): ModalFormFieldTypes[] => [
	{
		type: 'title',
		label: 'Ընդունելություն'
	},
	...((ROLE === 'CANDIDATE'
		? [
				{
					name: 'admissionFaculties',
					type: 'select',
					customApiFetch: {
						path:
							API[ROLE].USER.CUSTOM_API +
							`faculties?pagination=0&status=1&admissionYear=${moment().get('year')}`,
						labelKey: 'facultyName',
						valueKey: 'id'
					},
					label: 'Ընտրած ֆակուլտետ',
					tooltip: () =>
						'Դուք հնարավորություն ունեք ընտրել միայն մեկ ֆակուլտետ։ Հաստատելուց հետո այն ենթակա չէ փոփոխման',
					selectProps: {
						placeholder: 'Ընտրած ֆակուլտետ'
					},
					colProps: {
						xs: 24,
						lg: 12
					}
				}
		  ]
		: [
				{
					name: 'facultiesName',
					type: 'text',
					label: 'Ընտրած ֆակուլտետ',
					tooltip: () =>
						'Դուք հնարավորություն ունեք ընտրել միայն մեկ ֆակուլտետ։ Հաստատելուց հետո այն ենթակա չէ փոփոխման',
					colProps: {
						xs: 24,
						lg: 12
					}
				}
		  ]) as ModalFormFieldTypes[]),
	...(ROLE === 'CANDIDATE'
		? [
				{
					name: 'admissionLanguageExamID',
					type: 'select',
					fetchOnDepValue: true,
					isRequired: false,
					depFieldKey: 'admissionFaculties',
					// depValue: [
					// 	(val: number[] | number) => {
					// 		return Array.isArray(val)
					// 			? !!!props?.admissionFacultyIDs.includes(val[0])
					// 			: !!!props?.admissionFacultyIDs.includes(val);
					// 	}
					// ],
					customApiFetch: {
						path:
							API[ROLE].USER.CUSTOM_API +
							`settings/exams?isSelectable=1&pagination=0&admissionYear=${moment(
								Date.now()
							).format('YYYY')}&admissionFacultyID=`,
						labelKey: 'name',
						valueKey: 'id'
					},
					selectProps: {
						disableIfOptionsLength: true
					},
					label: 'Ի՞նչ լեզու եք ցանկանում հանձնել',
					colProps: {
						xs: 24,
						lg: 12
					}
				}
		  ]
		: ([
				{
					name: 'admissionLanguageExamName',
					type: 'text',
					// depFieldKey: ['admissionFaculties'],
					// depValue: [
					// 	(val: number[] | number) => {
					// 		return Array.isArray(val)
					// 			? !!!props?.admissionFacultyIDs.includes(val[0])
					// 			: !!!props?.admissionFacultyIDs.includes(val);
					// 	}
					// ],
					isRequired: false,
					label: 'Ի՞նչ լեզու եք ցանկանում հանձնել',
					colProps: {
						xs: 24,
						lg: 12
					}
				}
		  ] as ModalFormFieldTypes[])),
	{
		name: 'admissionLanguageExamPassTypeID',
		type: 'select',
		label: 'Ինչպե՞ս եք նախատեսում հանձնել այն',
		tooltip: () =>
			'Լեզվի վկայականի առկայության դեպքում, այն անհրաժեշտ է կցել «Փաստաթղթեր» բաժնում։ Միայն ՀՖՀՀ-ի կողմից հաստատվելուց հետո դիմորդը տվյալ առարկայից ստանում է առավելագույն միավոր՝ առանց օտար լեզվից քննություն հանձնելու։ Մանրամասների համար տե՛ս «ՀՖՀՀ ընդունելության կանոնակարգ», հոդված 2.1.7',
		depFieldKey: 'admissionLanguageExamID',
		depValue: (depValue: any) => !!depValue,
		isRequired: false,
		selectProps: {
			options: [
				{
					label: 'Քննության միջոցով',
					value: 1
				},
				{
					label: 'Ունեմ լեզվի վկայական',
					value: 2
				}
			],
			placeholder: 'Ինչպե՞ս եք նախատեսում հանձնել այն'
		},
		colProps: {
			xs: 24,
			lg: 12
		}
	},
	...(ROLE === 'CANDIDATE'
		? [
				{
					name: 'optionalSubjects',
					type: 'select',
					label: 'Կամընտրական առարկա',
					isRequired: true,
					tooltip: () =>
						'Ընդունվելու պարագայում առաջին կուրսի առաջին կիսամյակում ուսանելու եք կամընտրական առարկաներ, որոնց ընտրությունն անհրաժեշտ է կատարել հիմա։ Առաջին կիսամյակի ընթացքում դրանք փոփոխության ենթակա չեն։ \n ԻԿՄ ֆակուլտետի դիմորդները կարող են ընտրել ՄԻԱՅՆ մեկ առարկա։ Իրավաբանական, կառավարման, մարքեթինգի և ֆինանսների ֆակուլտետների դիմորդները կարող են ընտրել մեկ կամ երկու առարկա։ Օրինակ՝ «Գերմաներեն» կամ «Իսպաներեն» ընտրելու դեպքում դիմորդն այլ առարկա ընտրել չի կարող։ Հետևյալ առարկաներից դիմորդը կարող է ընտրել միայն երկուսը՝ «Հայկական քաղաքակրթություն», «Տրամաբանություն», «Հայոց լեզու», «Ֆիզիկական դաստիարակություն և սպորտ»',
					fetchOnDepValue: true,
					depFieldKey: 'admissionFaculties',
					depValue: (val: any) => {
						return Array.isArray(val) ? !!val?.length : !!val;
					},
					customApiFetch: {
						path: API[ROLE].USER.CUSTOM_API + 'optionalSubjects/',
						labelKey: (val: any) => `${val.name} (${val.credit} կրեդիտ)`,
						valueKey: 'id'
					},
					selectProps: {
						mode: 'multiple',
						placeholder: 'Կամընտրական առարկա'
					},
					colProps: {
						xs: 24,
						lg: 12
					}
				}
		  ]
		: ([
				{
					name: 'optionalSubjects',
					type: 'text',
					label: 'Կամընտրական առարկա',
					tooltip: () =>
						'Ընդունվելու պարագայում առաջին կուրսի առաջին կիսամյակում ուսանելու եք կամընտրական առարկաներ, որոնց ընտրությունն անհրաժեշտ է կատարել հիմա։ Առաջին կիսամյակի ընթացքում դրանք փոփոխության ենթակա չեն։ \n ԻԿՄ ֆակուլտետի դիմորդները կարող են ընտրել ՄԻԱՅՆ մեկ առարկա։ Իրավաբանական, կառավարման, մարքեթինգի և ֆինանսների ֆակուլտետների դիմորդները կարող են ընտրել մեկ կամ երկու առարկա։ Օրինակ՝ «Գերմաներեն» կամ «Իսպաներեն» ընտրելու դեպքում դիմորդն այլ առարկա ընտրել չի կարող։ Հետևյալ առարկաներից դիմորդը կարող է ընտրել միայն երկուսը՝ «Հայկական քաղաքակրթություն», «Տրամաբանություն», «Հայոց լեզու», «Ֆիզիկական դաստիարակություն և սպորտ»',
					colProps: {
						xs: 24,
						lg: 12
					}
				}
		  ] as ModalFormFieldTypes[]))
];
export default fields;
